import {Component, OnDestroy, OnInit} from '@angular/core';
import {ScriptService} from "../../../services/script.service";
import {ActivatedRoute} from "@angular/router";
import {AppComponent} from "../../../app.component";
import {labels} from "../../../../locale/labels";
import {environment} from "../../../../environments/environment";
import {Observable} from "rxjs";
import {BreakpointObserver, Breakpoints} from "@angular/cdk/layout";
import {map, shareReplay} from "rxjs/operators";

@Component({
  selector: 'app-liq-pay-widget',
  templateUrl: './liq-pay-widget.component.html',
  styleUrls: ['./liq-pay-widget.component.css']
})
export class LiqPayWidgetComponent implements OnInit, OnDestroy {
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  state: string = 'loading';
  params: object = null;
  errMsg: string = '';
  exitLabel: string = '';
  success_payment = false;
  private requestInterval = null;

  constructor(public application: AppComponent,
              public route: ActivatedRoute,
              private scriptService: ScriptService,
              private breakpointObserver: BreakpointObserver) { }

  ngOnInit(): void {
    this.state = 'loading';
    this.exitLabel = labels[AppComponent.appLang]['mobile_exit_default'];
    this.route.queryParams.subscribe(params => this.checkBookingParams(params));
  }
  ngOnDestroy(): void {
    this.clearSlotCheckerInterval()
  }

  private clearSlotCheckerInterval() {
    if (this.requestInterval) {
      clearInterval(this.requestInterval);
      this.requestInterval = null;
    }
  }
  private setupSlotCheckerInterval() {
    if (!this.requestInterval) {
      this.requestInterval = setInterval(() => this.liqPaySlotChecker(), 15000)
      this.liqPaySlotChecker();
    }
  }
  liqPaySlotChecker() {
    const params = this.params;
    this.application.apiService.checkLiqPaySlot(params, AppComponent.user ? AppComponent.user.magic_key : '')
      .subscribe(
        data => { /*slot ok*/ },
        error => this.handleSlotCheckError(error))
  }

  checkBookingParams(params:object): void {
    this.params = params;
    if(!params['cid'] || !params['sid'] || !params['qty'] || !params['pid'] || !params['sig']) {
      this.state = 'error';
      this.errMsg = 'Malformed request';
      this.exitLabel = labels[AppComponent.appLang]['mobile_exit_on_error'];
    } else {
      this.application.apiService.getLiqPayCheckoutParams(params, AppComponent.user ? AppComponent.user.magic_key : '')
        .subscribe(
          data => this.handleItem(data),
          error => this.handleItemsError(error))
    }
  }

  private handleItem(liqpayData) {
    //console.log('liqpayData',liqpayData['data'],liqpayData['signature']);
    this.state = 'show_booking_widget';
    let LiqPayCheckoutCallbackJS = 'window.LiqPayCheckoutCallback = function() {\n' +
      '      LiqPayCheckout.init({\n' +
      '        data: "'+liqpayData['data']+'",\n' +
      '        signature: "'+liqpayData['signature']+'",\n' +
      '        embedTo: "#liqpay_checkout",\n' +
      '        language: "uk",\n' +
      '        mode: "embed" // embed || popup\n' +
      '      }).on("liqpay.callback", function(data){\n' +
      '        console.log("liqpay.callback",data.status);\n' +
      '        console.log(data);\n' +
      '        window["liqpayAfterPaymentCallback"](data);;\n' +
      '      }).on("liqpay.ready", function(data){\n' +
      '        console.log("liqpay.ready");\n' +
      '      }).on("liqpay.close", function(data){\n' +
      '        console.log("liqpay.close!");\n' +
      '      });\n' +
      '    }';
    let LiqPayCheckoutCallbackScript = document.createElement('script');
    LiqPayCheckoutCallbackScript.type = 'text/javascript';
    LiqPayCheckoutCallbackScript.innerHTML = LiqPayCheckoutCallbackJS;
    document.getElementsByTagName('head')[0].appendChild(LiqPayCheckoutCallbackScript);
    this.scriptService.load('liqpay').then(data => {
      console.log('liqpay script loaded ', data);
    }).catch(error => console.log('liqpay script load error', error));
    window['liqpayAfterPaymentCallback'] = this.liqpayAfterPaymentCallback.bind(this);

    if(this.params['sid'] == 1 || this.params['pdata']) {
      this.setupSlotCheckerInterval();
    }
  }

  //private handleItemsError({ errMsg, exception: { status } }) {
  private handleItemsError(error) {
    console.log(error)
    this.state = 'error';
    this.clearSlotCheckerInterval();
    if(error.exception?.status == 409) {
      this.errMsg = AppComponent.getLabel('booking_conflict');
    } else {
      this.errMsg = error.errMsg;
    }
    this.exitLabel = labels[AppComponent.appLang]['mobile_exit_on_error'];
    // if (errMsg) {
    //   this.sharedDataService.pushNotification({ text: errMsg, type: 'error' })
    // }
  }
  private handleSlotCheckError(error) {
    if(this.success_payment) return;
    if(error.exception?.status == 409) {

      this.clearSlotCheckerInterval();
      this.state = 'error';
      this.errMsg = AppComponent.getLabel('booking_conflict');
    }
  }

  public liqpayAfterPaymentCallback(data) {
    console.log('liqpayAfterCallbackFunc', data)
    this.clearSlotCheckerInterval();
    let buttonLabel = (document.getElementById('exit_button') &&
      document.getElementById('exit_button').children &&
      document.getElementById('exit_button').children[0]) ? document.getElementById('exit_button').children[0] : null;
    if(!buttonLabel) return;
    if(data && data['status'] === 'success') {
      this.success_payment = true;
      buttonLabel.innerHTML = labels[AppComponent.appLang]['mobile_exit_on_success'];
    } else {
      buttonLabel.innerHTML = labels[AppComponent.appLang]['mobile_exit_on_error'];
    }
  }

  public exit() {
    //environment['mobile_exit_strategy']
    if(!environment['mobile_exit_strategy']) {
      window.alert('missing mobile_exit_strategy');
      return;
    }

    if(environment['mobile_exit_strategy'] === 'viber') {
      let exit_context = '';
      switch (this.state) {
        case 'loading':
        case 'start_checkout':
        case 'error':
          exit_context = '__exit_no_checkout';
          break;
        case 'success':
          exit_context = '__exit_success_checkout';
          break;
      }
      window.open(environment['viber_url']+exit_context)
    }
  }

}
